<template>
  <ClientOnly>
    <Teleport to="#notification-outlet">
      <Transition name="toast" appear>
        <BaseCard class="toast" shadow="shadow-flat-soft" :border-radius="10">
          <div
            v-if="props.icon"
            class="toast__icon-container"
            :style="backgroundColor"
          >
            <BaseIconSvg :name="props.icon" />
          </div>
          <div class="toast__content-wrapper">
            <slot />
            <button
              type="button"
              class="toast__close-button"
              @click="closeToast()"
            >
              <img src="@/assets/icons/close-navy.svg?url" />
            </button>
          </div>
        </BaseCard>
      </Transition>
    </Teleport>
  </ClientOnly>
</template>

<script lang="ts" setup>
interface Props {
  icon?: string
  bgColor?: string
}
const props = withDefaults(defineProps<Props>(), {
  icon: '',
  bgColor: '#FF8370',
})
const store = useToastStore()

const backgroundColor = computed(() => {
  return `background-color: ${props.bgColor}`
})

const closeToast = () => {
  store.toggleToast(false)
}
</script>

<style lang="scss" scoped>
.toast {
  @include paragraph-s;

  position: fixed !important;
  width: auto !important;
  top: 80px;
  left: 20px;
  right: 20px;
  transition: opacity 0.3s ease;
  z-index: 999999;

  @media (min-width: $breakpoint-md) {
    width: 658px !important;
    top: 164px;
    left: 50%;
    right: auto;
    transform: translate(-50%, 0);
  }

  &__icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 16px;
    svg {
      width: 40px;
      height: 40px;
    }
    @media (min-width: $breakpoint-md) {
      padding: 0 38px;
    }
  }

  &__content-wrapper {
    padding: 24px;
    gap: 24px;
    display: flex;
    flex-direction: column-reverse;

    @media (min-width: $breakpoint-md) {
      gap: 48px;
      padding: 24px 48px;
      flex-direction: row;
    }

    img {
      width: 16px;
    }
  }

  &__close-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &-leave-to,
  &-enter-from {
    opacity: 0;
  }
}
</style>
